import React from 'react';
import { Card, Alert, Badge, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getGoogleMapsDirectionsUrl } from '../shared/utils';

export default function TransportationInfoTab({ segments = [], isTemplate = false }) {
  const { t } = useTranslation();
  
  // Helper to translate activity type
  const translateActivityType = (type) => {
    if (type === 'transportation') {
      return t('planDetail.transportation.transportation');
    }
    if (type === 'accommodation') {
      return t('planDetail.transportation.accommodation');
    }
    return t('planDetail.transportation.activity');
  };

  return (
    <Card>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">{t('planDetail.transportation.transportationInfo')}</h5>
        </div>

        {segments.length === 0 ? (
          <Alert variant="warning">{t('planDetail.transportation.noSegmentsFound')}</Alert>
        ) : (
          <div>
            {segments.map((seg, idx) => (
              <Card key={idx} className="mb-2">
                <Card.Body className="py-2">
                  <Row className="align-items-center mb-2">
                    <Col xs="auto" className="small text-muted">
                      <i className="bi bi-calendar-date me-1"></i>
                      {isTemplate && seg.dayNumber != null ? `${t('planDetail.locations.day')} ${seg.dayNumber}` : seg.dayDate}
                    </Col>
                    <Col className="text-end"><Badge bg="secondary">#{idx + 1}</Badge></Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mb-2 mb-md-0">
                      <div className="fw-bold">{t('planDetail.transportation.from')}</div>
                      <div className="small">
                        {seg.fromName} <Badge bg="light" text="dark">{translateActivityType(seg.fromType)}</Badge>
                      </div>
                      <div className="small text-muted">{seg.fromTime}</div>
                      <div className="small text-truncate" title={seg.fromAddress}>{seg.fromAddress}</div>
                    </Col>
                    <Col md={6}>
                      <div className="fw-bold">{t('planDetail.transportation.to')}</div>
                      <div className="small">
                        {seg.toName} <Badge bg="light" text="dark">{translateActivityType(seg.toType)}</Badge>
                      </div>
                      <div className="small text-muted">{seg.toTime}</div>
                      <div className="small text-truncate" title={seg.toAddress}>{seg.toAddress}</div>
                    </Col>
                  </Row>
                  {seg.fromActivity && seg.toActivity && (
                    <div className="mt-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          const directionsUrl = getGoogleMapsDirectionsUrl(seg.fromActivity, seg.toActivity, seg.toRole);
                          if (directionsUrl) {
                            window.open(directionsUrl, '_blank');
                          }
                        }}
                      >
                        <span className="route-icon me-1"></span> {t('planDetail.transportation.getDirections')}
                      </Button>
                    </div>
                  )}
                </Card.Body>
              </Card>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
